import { Text } from '@workwhile/ui'
import React from 'react'
import { useDayforceWebhookDetailContextValue } from '../context/DayforceWebhookDetailProvider'
import { JobDetails } from 'pages/Dayforce/shared/components/JobDetails/JobDetails'

export const WorkerNcns = () => {
  const {
    state: { data },
  } = useDayforceWebhookDetailContextValue()

  const payloadData = data?.payloadBase64
    ? JSON.parse(atob(data.payloadBase64))
    : null
  const jobId = payloadData?.data?.shift?.job_id

  if (!jobId) {
    return <Text>Invalid payload</Text>
  }

  return <JobDetails agencyId={data.agencyId} jobId={jobId} />
}
